import React from 'react';
import 'chart.js/auto';
import { Bubble } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

const BubbleChart = (props) => {
    Chart.register(Title);

    return (
        <div>
            <Bubble key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default BubbleChart;
